import { useEffect, useState } from "react";
// components
import { Header } from "../../../components/Landing/Header/haeder.view";
import { BannerPostulacion } from "../components/BannerPostulacion";
import { Footer } from "../../../components/Landing/Footer";
// Hooks
import { UseVerConvocatorias } from "../../../hooks/UseVerConvocatorias";
import { useDocumentosAdministrativos } from "../../../hooks/useDocumentosAdministrativos";
// style component
import { Button } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
// style
import "../Usuario.style.scss";
import { RootState } from "../../../redux/reducers";
import { useSelector } from "react-redux";
import { DownloadFile } from "../../../utils/DownloadFile";
import { useNavigate } from "react-router-dom";
import apiParticipantes from "../../../api/Participantes/api-participantes";
import { useEncrypt } from "../../../hooks/useEncrypt";


export const DocumentosAdministrativos = () => {
  const { datos_postulacion } = useSelector(
    (state: RootState) => state.participantes
  );

  const { decrypt } = useEncrypt();

  const navigate = useNavigate();

  // redux

  const participante = useSelector((state: RootState) => state);

  const {
    getConvocatoriaPersistente,
    convocatoriaPersitente: convocatoria,
    setConvocatoriaPersitente,
    descargarArchivo,
  } = UseVerConvocatorias();
  const {
    guardarArchivosAdministrativos,
    eliminarArchivo,
    consultarArchivos,
    cargarPostulacionTipoParticipante,
    documentos,
    setDocumentos,
    loading,
  } = useDocumentosAdministrativos();

  const [documentosusuario, setDocumentosUsuario] = useState<any>([]);
  const [guardarFormulario, setGuardarFormulario] = useState(false);

  const getDocumentosAdministrativos = async () => {
    const { data } = await apiParticipantes.consultarDocumentosAdministrativos(decrypt(localStorage.getItem("id_postulacion")));
    setDocumentosUsuario(data.documentos_administrativos);
  }

  useEffect(() => {
    getConvocatoriaPersistente();
    cargarPostulacionTipoParticipante();
    getDocumentosAdministrativos();
  }, []);

  useEffect(() => {
    console.log('documentos', documentos)
    if (documentos.length > 0) {
      let nuevosdocumentos = documentos;
      nuevosdocumentos.map((documento) => {
        if (documentosusuario && documentosusuario.length > 0 && documento.url_participante === undefined) {
          const filterDocumentoAdministrativo = documentosusuario.filter((documentoAdministrativo) => documento.id == documentoAdministrativo.id);
          documento.url_participante = filterDocumentoAdministrativo[0] && filterDocumentoAdministrativo[0].url_participante !== "" ? filterDocumentoAdministrativo[0].url_participante : documento.url_participante;
        }
        return documento;
      });
      setDocumentos(nuevosdocumentos);
    }
  }, [documentosusuario, documentos]);

  return (
    <div>
      <Header />
      <BannerPostulacion convocatorias={convocatoria} />
      <div className="container-fluid2">
        <div className="row mt-4">
          <div className="col-12 no-margin font-family-Montserrat-Regular font-size-18px">
            <span className="font-family-Montserrat-SemiBold">
              ¡Ya casi terminamos! Carga los siguientes formatos PDF de documentación administrativa.
            </span>{" "}
            ¡Por favor completa los siguientes datos! Recuerda cargar la documentación solicitada en este paso, es importante para el proceso de postulación.
          </div>
        </div>
        <div className="col-12 mt-4">
          <div className="row">
            <div className="col-2 font-family-Montserrat-Regular font-size-18px numero-seleccionar-postulacion background-seleccionar-postulacion-verde">
              3
            </div>
            <div className="col font-family-Montserrat-Regular font-size-18px titulo-numero-postulacion">
              Documentación Administrativa.
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid2">
        <div className="row mt-4 mb-5">
          {documentos.map((data: any, index: number) => (
            <>
              <div className="col-12 col-md-6 col-lg-4 mt-3 mb-2">
                <div className="row m-0 cards-documentos">
                  <div className="col-12 mb-3 font-family-Montserrat-Bold font-size-14px">
                    {data.tipo_documento}
                  </div>
                  <div className="col-12 font-family-Montserrat-Regular font-size-14px">
                    {!data.url_participante && data.descripcion}
                  </div>
                  <div className="col d-flex">
                    {data.url_documento ? (
                      <Button
                        className="button-yellow-ghost"
                        style={{ paddingLeft: "0" }}
                        onClick={() => {
                          DownloadFile(
                            data.url_documento
                          );
                        }}
                      >
                        DESCARGAR FORMATO
                      </Button>
                    ) : (
                      <div
                        className=""
                        style={{ color: "#ff8900", marginTop: "25px" }}
                      >
                        SIN FORMATO
                      </div>
                    )}
                  </div>
                  <div className="col justify-content-flex-end">
                    <Button
                      className="button-gray-ghost pe-0 pb-0 m-0 mt-4"
                      onClick={() => {
                        let inputs: HTMLElement =
                          document.getElementsByClassName("inputs-ref")[
                          index
                          ] as HTMLElement;
                        inputs.click();
                      }}
                    >
                      CARGAR DOCUMENTO
                    </Button>
                    <input
                      className="inputs-ref"
                      type="file"
                      hidden
                      onChange={async (e) => {
                        guardarArchivosAdministrativos(data, e, index);
                        e.target.value = "";
                      }}
                    />
                  </div>
                  {data.url_participante && data.url_participante !== "" ? (
                    <div className="row m-0 background-color-00904C position-absolute-card-documento">
                      <div className="col-8 text-white">{data.descripcion}</div>
                      <div className="col-4 justify-content-flex-end text-white font-size-24px">
                        <CheckCircleOutlined />
                      </div>
                      <div
                        id="tipo_doc"
                        className="col-10 mb-3 font-family-Montserrat-Bold font-size-14px font-color-FFFFFF"
                      >
                        {data.tipo_documento}
                      </div>
                      <div className="col-6 justify-content-flex-end">
                        <Button
                          className="button-blanco-ghost text-uppercase font-family-Montserrat-Regular"
                          style={{ paddingLeft: "0" }}
                          onClick={(e) => {
                            const filterDoc = documentosusuario.filter((documentoAdmin) => documentoAdmin.id !== data.id);
                            setDocumentosUsuario(filterDoc);
                            eliminarArchivo(e, index, data.id)
                          }
                          }
                        >
                          Eliminar
                        </Button>
                      </div>
                      <div className="col-6">
                        <Button className="button-blanco-ghost font-family-Montserrat-Bold text-uppercase">
                          Cargado
                        </Button>
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            </>
          ))}
        </div>
      </div>
      <div
        className="container-fluid2 bg-white"
        style={{
          justifyContent: "center",
          position: "sticky",
          bottom: 0,
          paddingBottom: "0%",
        }}
      >
        <div className="col justify-content-flex-end">
          <Button
            style={{ marginRight: "1%" }}
            type="link"
            className="button-blanco-radius font-size-12px"
            disabled={loading}
            onClick={
              () => {
                consultarArchivos(true)
              }
            }
          >
            Guardar y salir
            {loading && (
              <i
                className="fa fa-spinner fa-spin"
                style={{ fontSize: 12, marginLeft: 4, color: "#fff" }}
              />
            )}
          </Button>
          <Button
            style={{ marginRight: "1%" }}
            type="link"
            className="button-blanco-radius font-size-12px"
            onClick={() => navigate("/usuario/seleccionarCategoria")}
          >
            Atrás
          </Button>
          <Button
            type="link"
            className="button-azul-radius font-size-12px"
            onClick={() => consultarArchivos(false)}
            disabled={loading}
          >
            Continuar
            {loading && (
              <i
                className="fa fa-spinner fa-spin"
                style={{ fontSize: 12, marginLeft: 4, color: "#fff" }}
              />
            )}
          </Button>
        </div>
      </div>
      <Footer />
    </div>
  );
};
